import styled from "styled-components";

export const Card = styled.div`
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  background: white;
`;
